import "./team.css"
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import docone from "../../img/doctorone.avif"
import doctwo from "../../img/doctortwo.avif"
import docthree from "../../img/doctorthree.avif"
import docfour from "../../img/doctorfour.webp"
import docfive from "../../img/doctorfive.webp"
import docsix from "../../img/docsix.webp"
import { Link } from "react-router-dom";


function Team(){
     const gettop=()=>{
    window.scrollTo({
      top:0,
      behavior:"smooth"
    })
  }
    return(
        <>
        <div className="team">
           <div className="continer">
    <h4>Our Medical Team</h4>
    <h5>A select group of specialized doctors providing the best medical care</h5>
</div>
<div className="content">
    <div className="row m-2 g-2">

  {/* 1 */}
  <div className="col-md-4">
    <Card style={{ width: '100%' }}>
      <Card.Img variant="top" src={docone} />
      <Card.Body>
        <Card.Title>Dr. John H. Watson</Card.Title>
        <Card.Title>Chronic Disease Clinic</Card.Title>

        <Card.Text>
          Former British Army surgeon and the famous companion of Sherlock Holmes.
          Dr. Watson has extensive experience in internal medicine and surgery.
          He is known for handling complex medical cases and providing accurate
          diagnosis and compassionate patient care.
        </Card.Text>

        <Card.Text>Email: john.watson@medicalcenter.com</Card.Text>
        <Card.Text>Phone: +20 100 123 4567</Card.Text>

      </Card.Body>
    </Card>
  </div>

  {/* 2 */}
  <div className="col-md-4">
    <Card style={{ width: '100%' }}>
      <Card.Img variant="top" src={doctwo} />
      <Card.Body>
        <Card.Title>Dr. Sarah Williams</Card.Title>
        <Card.Title>Family Medicine Clinic</Card.Title>

        <Card.Text>
          Dr. Sarah Williams is a family medicine specialist with strong
          experience in preventive healthcare and long-term patient care.
          She focuses on providing comprehensive medical services for
          individuals and families of all ages in all the worlds.
        </Card.Text>

        <Card.Text>Email: sarah.williams@medicalcenter.com</Card.Text>
        <Card.Text>Phone: +20 101 234 5678</Card.Text>
        
      </Card.Body>
    </Card>
  </div>

  {/* 3 */}
  <div className="col-md-4">
    <Card style={{ width: '100%' }}>
      <Card.Img variant="top" src={docthree} />
      <Card.Body>
        <Card.Title>Dr. Michael Brown</Card.Title>
        <Card.Title>Physical Therapy Specialist</Card.Title>

        <Card.Text>
          Dr. Michael Brown specializes in physical therapy and rehabilitation.
          He helps patients recover mobility and strength after injuries or
          surgeries using modern therapy techniques and personalized
          rehabilitation programs in all the world.
        </Card.Text>

        <Card.Text>Email: michael.brown@medicalcenter.com</Card.Text>
        <Card.Text>Phone: +20 102 345 6789</Card.Text>
        
      </Card.Body>
    </Card>
  </div>

  {/* 4 */}
  <div className="col-md-4">
    <Card style={{ width: '100%' }}>
      <Card.Img variant="top" src={docfour} />
      <Card.Body>
        <Card.Title>Dr. Emily Johnson</Card.Title>
        <Card.Title>General Checkup Clinic</Card.Title>

        <Card.Text>
          Dr. Emily Johnson provides comprehensive health examinations
          focused on early disease detection and preventive care. She is
          dedicated to helping patients maintain a healthy lifestyle
          through proper medical guidance in all the world.
        </Card.Text>

        <Card.Text>Email: emily.johnson@medicalcenter.com</Card.Text>
        <Card.Text>Phone: +20 103 456 7890</Card.Text>
        
      </Card.Body>
    </Card>
  </div>

  {/* 5 */}
  <div className="col-md-4">
    <Card style={{ width: '100%' }}>
      <Card.Img variant="top" src={docfive} />
      <Card.Body>
        <Card.Title>Dr. David Smith</Card.Title>
        <Card.Title>Pediatric Clinic</Card.Title>

        <Card.Text>
          Dr. David Smith is a pediatric specialist dedicated to providing
          medical care for infants and children. He focuses on child health,
          vaccinations, and early development monitoring in all the world in all the section.
        </Card.Text>

        <Card.Text>Email: david.smith@medicalcenter.com</Card.Text>
        <Card.Text>Phone: +20 104 567 8901</Card.Text>
        
      </Card.Body>
    </Card>
  </div>

  {/* 6 */}
  <div className="col-md-4">
    <Card style={{ width: '100%' }}>
      <Card.Img variant="top" src={docsix} />
      <Card.Body>
        <Card.Title>Dr. Anna Taylor</Card.Title>
        <Card.Title>Medical Laboratory Specialist</Card.Title>

        <Card.Text>
          Dr. Anna Taylor is responsible for medical laboratory analysis
          and diagnostic testing. She ensures accurate laboratory results
          that help doctors provide the best diagnosis and treatment plans
          for patients in all the world.
        </Card.Text>

        <Card.Text>Email: anna.taylor@medicalcenter.com</Card.Text>
        <Card.Text>Phone: +20 105 678 9012</Card.Text>
        
      </Card.Body>
    </Card>
  </div>

</div>
<div className="row">
    <div className="col-md-12 mx-auto text-center mt-4">
                <Link to="/Doctors" className="nav-link"  onClick={gettop}>
                    <Button variant="danger w-50">Meet Our Medical Team</Button>

                </Link>


    </div>
</div>
     
</div>

        </div>
        </>
    )
}
export default Team